import axios from 'axios'
import { requestInterceptor, responseInterceptor, errorInterceptor, resetRefreshState } from './interceptors'

export { resetRefreshState }

export const getApiBaseUrl = (): string => {
  const envUrl = import.meta.env.VITE_API_BASE_URL
  if (envUrl && envUrl.trim() !== '') {
    return envUrl.trim().replace(/\/+$/, '')
  }
  // In local development (localhost / 127.0.0.1) when no explicit base URL is configured,
  // use relative path '' so Vite proxy handles /api
  if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    return ''
  }

  // Fallback to configured cloud API / dev proxy
  return 'https://api.ledryt.com'
}

const apiClient = axios.create({
  baseURL: getApiBaseUrl(),
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': 'true',
  },
})

// Register Axios Interceptors
apiClient.interceptors.request.use(requestInterceptor)
apiClient.interceptors.response.use(responseInterceptor, errorInterceptor)

export default apiClient
